// import { Container, Row, Col, Card } from 'react-bootstrap';
// import projImg1 from "../assets/img/wow.jpg";
// import projImg2 from "../assets/img/mobile-app.jpg";
// import projImg3 from "../assets/img/software-development.jpg";
// import colorSharp from "../assets/img/color-sharp3.png";

import ScrollAnim from './ScrollAnim';

export const ServiceDetails = () => {
   
    return (
        <section id="details">
            <ScrollAnim animation="animate__slideInDown"><h3 className="text-center mt-5">Palawan Freelancer can encompass a wide range of services, including:</h3></ScrollAnim>
            
            <ScrollAnim animation="animate__fadeInLeft">
                <div className="dl-blurbs">

          
                    <dl>
                        <dt>Website design and layout</dt>
                        <dd>This includes creating the visual design and layout of a website, including the color scheme, typography, and overall aesthetic.</dd>

                        <dt>User experience (UX) design</dt>
                        <dd>This involves designing the website in a way that makes it easy for visitors to navigate, find the information they need, and complete any desired actions, such as making a purchase or filling out a contact form.</dd>

                        <dt>Web development</dt>
                        <dd>This includes coding the functionality of the website, such as creating forms, integrating with third-party services, and building custom features using programming languages.</dd> 
                        {/* HTML, CSS, JavaScript, and PHP. */}
                    </dl>
                    <dl>
                        <dt>Search engine optimization (SEO)</dt>
                        <dd>This is the process of making a website more visible in search engine results, and typically includes optimizing the website's content and code for certain keywords and phrases.</dd>

                        <dt>Mobile optimization</dt>
                        <dd>As the number of people using mobile devices to access the internet continues to grow, it's crucial that websites are optimized for mobile devices to ensure they load quickly and look good on smaller screens.</dd>

                        <dt>Website maintenance</dt>
                        <dd>Once a website is live, it's important to regularly update it with new content, fix any bugs, and make sure that the website is still performing well and meets the latest web standards.</dd>
                    </dl>
              
                </div>
                </ScrollAnim>
            
           
           

        </section>
    )
}

